export class RegisterModel {
    mobileNumber: string;
    fullName: string;
    email: string;
    newPassword: string;
    confirmPassword: string;
    token: string;
  }